import React from 'react';
import './style.scss';
import LogoListingCard from '../card';
import clsx from 'clsx';

const LogoListingGrid = ({ items, mode = 'normal' }) => (
  <div className={clsx('logo-listing-grid', mode === 'modal' && 'logo-listing-grid-modal')}>
    {items.map((item, index) => (
      <LogoListingCard data={item} className="ll-grid-card" key={index} />
    ))}
  </div>
);

export default LogoListingGrid;
